import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { KeyboardDoubleArrowDown, KeyboardDoubleArrowRight } from '@mui/icons-material';

interface Props extends IconButtonProps {
  expanded?: boolean,
  downDirection?: boolean,
  tooltip?: string,
  iconColor?: string,
}

const ExpandIcon = ({ expanded, downDirection, tooltip = '', iconColor, ...props }: Props) => {
  const theme = useTheme();
  return (
    <Tooltip title={tooltip}>
      <IconButton sx={{
        color: iconColor || theme.palette.primary.dark,
        fontSize: { mobile: 20, laptop: 28 },
        transform: `rotate(${expanded ? '180deg' : ''})`,
        transition: 'all .2s ease-out',
        ...props.sx
      }} {...props}>
        {
          downDirection
            ? <KeyboardDoubleArrowDown/>
            : <KeyboardDoubleArrowRight/>
        }

      </IconButton>
    </Tooltip>

  );
};

export default ExpandIcon;